let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("deyvi"), load("4UPfH"), load("cdeuH"), load("c2KB7")]).then(() => parcelRequire('aU3fj'));